export default "__VITE_ASSET__C63P66lG__"